<!--  -->
<template>
  <div class="overview">
    <div class="map-species">
      <div class="map">
        <v-map :mapData="markers" v-if="nodeId"></v-map>
      </div>
      <div class="species">
        <h3 class="title">
          <span v-if="routerName == 'TibetPlateau'">List of Fossil Sites</span>
          <span v-else>List of Species</span>
        </h3>
        <div class="list-species">
          <ul class="list-ul" v-if="routerName == 'TibetPlateau'">
            <li v-for="(item, index) in speciesList">
              <span :class="'opacity-' + (10 - 2 * index)">{{
                index + 1
              }}</span>
              <a>
                <i :class="{ italic: item.s_italic }" v-if="item.properties">{{
                  innerHTML(item.properties.f_site_place)
                }}</i>
              </a>
            </li>
          </ul>
          <ul class="list-ul" v-else>
            <li v-for="(item, index) in speciesList">
              <span :class="'opacity-' + (10 - 2 * index)">{{
                index + 1
              }}</span>
              <a>
                <i :class="{ italic: item.s_italic }">{{
                  innerHTML(item.s_en_name)
                }}</i>
                {{ innerHTML(item.s_mmr)
                }}<i v-if="item.s_mmsj">,{{ innerHTML(item.s_mmsj) }}</i>
              </a>
            </li>
          </ul>
          <p v-if="!speciesList.length" class="no-data">Temporarily no data</p>
          <!-- <v-page :showPagination="show" :event="getResult" @getList='getList' :limit="per_page" :totalPage="speciesTotalPage" :totalCount="totalCount" :nodeId="nodeId"></v-page> -->
          <el-pagination
            @current-change="handleCurrentChange"
            :total="totalCount"
            :current-page="currentPage"
            :page-size="per_page"
            layout="prev,slot,next"
          >
            <span class="rightPagination">
              {{ currentPage }}/{{ speciesTotalPage }}
            </span>
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="literature">
      <h3 class="title">
        <span>List of Literature</span>
        <router-link to="/literature/index" class="more">View More</router-link>
      </h3>
      <p v-if="!literatureList.length" class="no-data">Temporarily no data</p>
      <div class="list-literature" v-else>
        <ul class="literature-ul">
          <li
            v-for="(item) in literatureList"
            :key="item.s_id + '_' + item.r_id"
          >
            <span class="list-type"></span>
            <router-link :to="'/literature_details/' + item.r_id"
              >{{ innerHTML(item.literature.r_author) }},{{
                innerHTML(item.literature.r_joint_author)
              }},{{ innerHTML(item.literature.r_year) }}</router-link
            >
            {{ innerHTML(item.literature.r_title) }},{{
              innerHTML(item.literature.r_journal)
            }},{{ innerHTML(item.literature.r_volume) }},{{
              innerHTML(item.literature.r_pages)
            }}
            <router-link
              :to="'https://doi.org/' + item.literature.r_doi"
              target="_blank"
              >{{ item.literature.r_doi }}</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getLiterature,
  getSpecies,
  getFossillist,
  getAllLocations,
  getFossilGps,
  getAllPoints,
  getFossilDetails,
  utlogMap
} from "@/api/index";
import VMap from "@/components/map.vue";
import VPage from "@/components/pagenation/index.vue";
import { mixins } from "@/mixins/index.js";
import { features } from "@/points.js";
import { functionId } from "@/utils/browser.js";
let polyPoints = [];
for (let i = 0; i < features.length; i++) {
  let coordinates = features[i].geometry.coordinates;
  coordinates.forEach((el) => polyPoints.push(...el));
}
export default {
  mixins: [mixins],
  components: {
    VMap,
    VPage,
  },
  props: ["nodeId"],
  data() {
    return {
      markers: [],
      speciesTotalPage: 1,
      totalCount: 5,
      per_page: 5,
      mapData: {
        points: [
          {
            centerPoints: [39.61, -105.02],
            title: "测试一下行不行1",
          },
          {
            centerPoints: [39.74, -104.99],
            title: "测试一下行不行2",
          },
        ],
      },
      speciesList: [],
      tempSpeciesList: [],
      literatureList: [],
      currentPage: 1,
      points: [],
      routerName: "",
      tibetName: "TibetPlateau",
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    // this.getAllLocations();
    // this.getLiterature();
    // this.getSpecies();
    this.routerName = this.$route.name;
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.routerName == this.tibetName) {
        this.$set(
          this,
          "speciesList",
          this.tempSpeciesList.slice(
            this.per_page * (val - 1),
            this.per_page * val
          )
        );
      } else {
        this.getSpecies();
        let logMap = {
          eventType: "clk",
          url: window.location.href,
          functionId: (this.routerName == this.tibetName)?'Deepbone_tibet_speciesPageChange': 'Deepbone_explore_speciesPageChange' 
        };
        utlogMap(logMap).then((res) => {
        //   console.log(res);
        });
      }
    },
    getResult(page) {
      return getSpecies(this.nodeId, this.per_page, page);
    },
    getList(list) {
      this.$set(this, "speciesList", list);
    },
    getSpecies() {
      getSpecies(this.nodeId, this.per_page, this.currentPage).then((res) => {
        let data = res.data?.data || [];
        let meta = res.data?.meta || {};
        let { totalCount = 0, totalPage = 0, Page = 1 } = meta;
        this.totalCount = totalCount;
        this.speciesTotalPage = totalPage;
        this.$set(this, "speciesList", data);
      });
    },
    getLiterature() {
      getLiterature(this.nodeId, 10, this.currentPage).then((res) => {
        let data = res.data?.data || [];
        this.$set(this, "literatureList", data);
      });
    },
    trim(str) {
      return parseFloat(str.split(" ").join(""));
    },
    getAllLocations() {
      getAllLocations(this.nodeId).then((res) => {
        let data = res.data?.data || [];
        let markers = [];
        data.forEach((el, index) => {
          let points = el.location.split(",");
          if (
            points.length != 2 ||
            this.trim(points[0]) != points[0] ||
            this.trim(points[1]) != points[1]
          )
            return;
          markers.push({
            centerPoints: [this.trim(points[1]), this.trim(points[0])], //lat lng
            //[39.89491,116.322056] 北京的 维度,经度 (lat,lng)
            title: el.f_specimen_number,
          });
        });
        this.$set(this, "markers", markers);
      });
    },
    getFossilGps() {
      getFossilGps(this.nodeId).then((res) => {
        let data = res.data?.features || [];
        let markers = [];
        let points = [];
        data.forEach((el, index) => {
          let properties = el.properties;
          let { f_specimen_number, f_site_latitude, f_site_longtitude } =
            properties;
          for (let i = 0; i < polyPoints.length; i++) {
            let isPointInPath = this.IsPtInPoly(
              f_site_longtitude,
              f_site_latitude,
              polyPoints[i]
            );
            if (isPointInPath) {
              points.push(el);
              markers.push({
                centerPoints: [f_site_latitude, f_site_longtitude],
                title: f_specimen_number,
              });
              return;
            }
          }
        });
        this.$emit("updateMarkers", points);
        this.$set(this, "points", points);
        let tempSpeciesList = points.filter(
          (el) => el.properties.f_site_place != ""
        );
        this.totalCount = tempSpeciesList.length;
        this.speciesTotalPage = Math.ceil(
          tempSpeciesList.length / this.per_page
        );
        this.$set(this, "tempSpeciesList", tempSpeciesList);
        this.$set(this, "speciesList", tempSpeciesList.slice(0, this.per_page));
        this.$set(this, "markers", markers);
      });
    },
    IsPtInPoly(ALon, ALat, APoints) {
      var iSum = 0,
        iCount;
      var dLon1, dLon2, dLat1, dLat2, dLon;
      if (APoints.length < 3) return false;
      iCount = APoints.length;
      for (var i = 0; i < iCount; i++) {
        if (i == iCount - 1) {
          dLon1 = APoints[i][0];
          dLat1 = APoints[i][1];
          dLon2 = APoints[0][0];
          dLat2 = APoints[0][1];
        } else {
          dLon1 = APoints[i][0];
          dLat1 = APoints[i][1];
          dLon2 = APoints[i + 1][0];
          dLat2 = APoints[i + 1][1];
        }
        //以下语句判断A点是否在边的两端点的水平平行线之间，在则可能有交点，开始判断交点是否在左射线上
        if (
          (ALat >= dLat1 && ALat < dLat2) ||
          (ALat >= dLat2 && ALat < dLat1)
        ) {
          if (Math.abs(dLat1 - dLat2) > 0) {
            //得到 A点向左射线与边的交点的x坐标：
            dLon = dLon1 - ((dLon1 - dLon2) * (dLat1 - ALat)) / (dLat1 - dLat2);
            if (dLon < ALon) iSum++;
          }
        }
      }
      if (iSum % 2 != 0) return true;
      return false;
    },
    initLiterature(literature_list) {
      this.$set(this, "relatedLiteratureList", literature_list);
    },
  },
  watch: {
    nodeId: function (newVal, oldVal) {
      if (newVal != oldVal && newVal != "") {
        this.currentPage = 1;
        //当前是home执行全部
        if (this.$route.name == "TibetPlateau") {
          this.getFossilGps();
          return;
        } else {
          this.getAllLocations();
        }

        this.getLiterature();
        this.getSpecies();
      }
    },
    points: function (val) {
      let relatedLiterature = [];
      let relatedLiteratureId = new Set();
      if (val) {
        let len = val.length >= 10 ? 10 : val.length;
        let req = [];
        for (let i = 0; i < len; i++) {
          let fossil_id = val[i].properties.fossil_id;
          req.push(getFossilDetails(fossil_id));
        }
        Promise.all(req).then((res) => {
          for (let i = 0; i < res.length; i++) {
            let data = res[i].data?.data;
            let literature_list = data["literature_list"];
            if (literature_list.length) {
              for (let j = 0; j < literature_list.length; j++) {
                if (!relatedLiteratureId.has(literature_list[j].r_id)) {
                  relatedLiteratureId.add(literature_list[j].r_id);
                  relatedLiterature.push(literature_list[j]);
                }
              }
            }
          }
          this.$set(this, "literatureList", relatedLiterature);
        });
      }
    },
  },
};
</script>
<style>
.leaflet-right .leaflet-control {
  margin-right: 0 !important;
}
.leaflet-left .leaflet-control {
  margin-left: 0 !important;
}
.map-species {
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 310px;
  justify-content: space-between;
}
.map {
  width: 45%;
  /* background: url("../../../assets/images/map.png") no-repeat center; */
}
.species {
  width: calc(55% - 12px);
  margin-left: 12px;
  border: 2px solid #efefef;
  padding: 0 20px 20px;
}
.list-species {
  position: relative;
  height: calc(100% - 68px);
}
.list-ul li {
  height: 38px;
  font-weight: 500;
  font-size: 16px;
  line-height: 37px;
  color: #72c2c9;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-ul li > span {
  display: inline-block;
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  color: white;
  font-weight: 500;
  background: #189ca9;
  mix-blend-mode: darken;
  border-radius: 4px;
  margin-right: 10px;
}
.list-ul a {
  font-size: 16px;
  color: #484d63;
}
.list-ul i.italic {
  font-style: italic;
}
.list-ul a:hover {
  color: #72c2c9;
}
.literature {
  min-height: 376px;
  margin-top: 12px;
  padding: 0 20px 20px 20px;
}
.literature-ul li {
  padding-left: 18px;
  position: relative;
  line-height: 24px;
  margin-bottom: 6px;
}
.literature-ul .list-type {
  position: absolute;
  left: 0;
  top: 8px;
  width: 8px;
  height: 8px;
  background: #484d63;
  mix-blend-mode: darken;
  border-radius: 50px;
}
.literature-ul a {
  color: #72c2c9;
}
</style>
